sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var PendingUsers = BlockBase.extend("com.reply.leaviosa.blocks.admin.PendingUsers", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.admin.PendingUsers",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.admin.PendingUsers",
					type: ViewType.XML
				}
			}
		}
	});

	return PendingUsers;
});